// Translations for public flow start page
export const T = {
  en_GB: {
    flowNotFound: "Flow not found or not available for public access",
    flowNotConfigured: "This flow is not configured for public access",
    failedToLoad: "Failed to load flow",
    getStarted: "Get Started",
    chooseVerification: "Choose how you'd like to verify your identity",
    fullName: "Full Name",
    enterFullName: "Enter your full name",
    verificationMethod: "Verification Method",
    email: "Email",
    sms: "SMS",
    emailAddress: "Email Address",
    emailPlaceholder: "your.email@example.com",
    emailHint: "We'll send a 6-digit verification code to this email",
    phoneNumber: "Phone Number",
    phonePlaceholder: "+1 (555) 123-4567",
    phoneHint: "We'll send a 6-digit verification code via SMS",
    sendCode: "Send Verification Code",
    enterCode: "Enter Verification Code",
    codeSentTo: "We sent a 6-digit code to",
    verificationCode: "Verification Code",
    codeExpires: "Code expires in 10 minutes",
    back: "Back",
    verifying: "Verifying...",
    verifyStart: "Verify & Start",
    didntReceive: "Didn't receive a code? Try again",
    secureConnection: "Secure Connection",
    securityNotice:
      "Your information is encrypted and stored securely. We will only use your contact information to verify your identity and communicate with you about this form.",
    pleaseEnterName: "Please enter your name",
    pleaseEnterEmail: "Please enter your email address",
    pleaseEnterValidEmail: "Please enter a valid email address",
    pleaseEnterPhone: "Please enter your phone number",
    pleaseEnterCode: "Please enter the 6-digit verification code",
    sessionExpired: "Session expired. Please start over.",
    failedToSendCode: "Failed to send verification code",
    failedToVerifyCode: "Failed to verify code",
  },
  nb_NO: {
    flowNotFound: "Flyt ikke funnet eller ikke tilgjengelig for offentlig tilgang",
    flowNotConfigured: "Denne flyten er ikke konfigurert for offentlig tilgang",
    failedToLoad: "Kunne ikke laste flyt",
    getStarted: "Kom i gang",
    chooseVerification: "Velg hvordan du vil bekrefte identiteten din",
    fullName: "Fullt navn",
    enterFullName: "Skriv inn ditt fulle navn",
    verificationMethod: "Verifiseringsmetode",
    email: "E-post",
    sms: "SMS",
    emailAddress: "E-postadresse",
    emailPlaceholder: "din.epost@eksempel.no",
    emailHint: "Vi sender en 6-sifret bekreftelseskode til denne e-postadressen",
    phoneNumber: "Telefonnummer",
    phonePlaceholder: "+47 123 45 678",
    phoneHint: "Vi sender en 6-sifret bekreftelseskode via SMS",
    sendCode: "Send bekreftelseskode",
    enterCode: "Skriv inn bekreftelseskode",
    codeSentTo: "Vi sendte en 6-sifret kode til",
    verificationCode: "Bekreftelseskode",
    codeExpires: "Koden utløper om 10 minutter",
    back: "Tilbake",
    verifying: "Verifiserer...",
    verifyStart: "Bekreft og start",
    didntReceive: "Mottok du ikke koden? Prøv igjen",
    secureConnection: "Sikker tilkobling",
    securityNotice:
      "Informasjonen din er kryptert og lagret sikkert. Vi vil kun bruke kontaktinformasjonen din til å bekrefte identiteten din og kommunisere med deg om dette skjemaet.",
    pleaseEnterName: "Vennligst skriv inn navnet ditt",
    pleaseEnterEmail: "Vennligst skriv inn e-postadressen din",
    pleaseEnterValidEmail: "Vennligst skriv inn en gyldig e-postadresse",
    pleaseEnterPhone: "Vennligst skriv inn telefonnummeret ditt",
    pleaseEnterCode: "Vennligst skriv inn den 6-sifrede bekreftelseskoden",
    sessionExpired: "Økten har utløpt. Vennligst start på nytt.",
    failedToSendCode: "Kunne ikke sende bekreftelseskoden",
    failedToVerifyCode: "Kunne ikke bekrefte koden",
  },
} as const;
